<template>
  <section class="bg-white py-3">
    <div class="mb-3 text-gray-700 fw-bolder">Привязано к</div>
    <div class="row">
     <div class="col-xl-3 col-md-6">
       <checkbox-field
           v-model="filter.isDep"
           placeholder="Департамент"
           id="filter.isDep"
           class="form-check-sm h-35px rounded border ps-2 border-gray-300"
       />
     </div>
     <div class="col-xl-9 col-md-6">
       <v-select
           v-if="dUsers"
           v-model="filter.user"
           :options="filter.isDep ? dDep : dUsers"
           :reduce="item => item.id"
           :placeholder="filter.isDep ? 'Выберите департамент' : 'Выберите сотрудника'"
           inputId="users.search.filter.user"
           class="mb-3 bg-white"
           label="name"
       ></v-select>
     </div>
    </div>
    <hr class="text-gray-400 mt-1">
    <div class="mb-3 text-gray-700 fw-bolder">Дополнительно</div>
    <div class="row">
      <div class="col-xl-2 col-md-6">
        <div class="input-group input-group-sm mb-3">
          <input v-model="filter.iin" type="text" class="form-control" name="filter.iin" id="filter.iin" placeholder="ИИН/БИН"/>
        </div>
      </div>
      <div class="col-xl-4 col-md-6">
        <div class="input-group input-group-sm mb-3">
          <input v-model="filter.title" type="text" class="form-control" name="filter.title" id="filter.title" placeholder="Ф.И.О"/>
        </div>
      </div>
      <div class="col-xl-3 col-md-6">
        <v-select
            v-model="filter.role"
            :options="roles"
            :reduce="item => item.id"
            inputId="users.search.filter.role"
            placeholder="Роль"
            class="mb-3 bg-white"
            label="name"
        ></v-select>
      </div>
      <div class="col-xl-3 col-md-6">
        <v-select
            v-model="filter.type"
            :options="types"
            :reduce="item => item.id"
            inputId="users.search.filter.type"
            placeholder="Тип"
            class="mb-3 bg-white"
            label="name"
        ></v-select>
      </div>
    </div>
    <div class="row justify-content-between">
      <div class="col-xl-2 col-md-6">
        <button type="button" class="btn btn-block btn-light-warning btn-sm" @click="clear">Очистить</button>
      </div>
      <div class="col-xl-2 col-md-6">
        <button type="button" class="btn btn-block btn-primary btn-sm" @click="search">Поиск</button>
      </div>
    </div>
  </section>
</template>

<script>
import CheckboxField  from '@/components/Fields/CheckboxField'
import vSelect        from 'vue-select'

export default {
  name: 'BranchEmployeesSearch',
  components: { CheckboxField, vSelect },
  props: {
    filter: null,
    dUsers: null,
    dDep:   null
  },
  data() {
    return {
      roles: [
          {id: 0, name: 'Администратор'},
          {id: 1, name: 'Модератор'},
          {id: 2, name: 'Бухгалтер'},
          {id: 3, name: 'Менеджер'},
          {id: 4, name: 'Агент'},
          {id: 6, name: 'ДРМ ПОДФТ'},
          {id: 7, name: 'Сервис менеджер'},
      ],
      types: [
          {id: 0, name: 'Нет 1C'},
          {id: 1, name: 'C 1C'},
          {id: 2, name: 'Локальный'},
      ]
    }
  },
  methods: {
    search() {
      this.$emit('search', true)
    },
    clear() {
      this.filter.isDep = false
      this.filter.user  = null
      this.filter.type  = null
      this.filter.role  = null
      this.filter.title = ''
      this.filter.iin   = ''
      this.$emit('search', true)
    }
  },
  watch: {
    'filter.isDep': {
      immediate: true,
      handler(val) {
        if (val !== null) this.filter.user = null
      }
    }
  }
}
</script>

<style scoped>

</style>